import { translateBlock } from 'i18n';

import { Theme } from '@mui/system';

import { capitalize } from 'helpers/helpers';
import { getOptionFunction } from 'routes/Explore/components/Sentence/helpers/treeData';
import { LibraryIndicatorT } from 'business/definitions';
import {
    INDICATOR_TAG_TYPES,
    IndicatorTagT,
    IndicatorTagTypeT,
    isCityIndicator,
} from './types';

export function getChipColorFromIndicatorTag(
    indicatorFilterType: IndicatorTagTypeT,
    theme: Theme,
): string {
    const colorToTagMapper = {
        [INDICATOR_TAG_TYPES.chartType]: theme.palette.red,
        [INDICATOR_TAG_TYPES.connector]: theme.palette.green,
        [INDICATOR_TAG_TYPES.metric]: theme.palette.darkBlue,
        [INDICATOR_TAG_TYPES.title]: theme.palette.darkGrey,
    };
    return colorToTagMapper[indicatorFilterType] as string;
}

export const getAvailableFunctionsFromMetrics = (
    metrics: AvailableMetricT[] | ExploreMetricT[] | undefined,
): string[] => {
    if (!metrics) return [];
    const metricsFunctions = metrics.map((metric) =>
        getOptionFunction(metric.functions || []),
    );
    const uniqAvailableFunctions = Array.from(new Set(metricsFunctions.flat()));
    return uniqAvailableFunctions;
};

export function getIndicatorTags(
    indicator: LibraryIndicatorT,
    t: TranslationT,
): IndicatorTagT[] {
    const indicatorVizTypeTag = {
        value: t(`settings.${indicator.vizType}`),
        type: INDICATOR_TAG_TYPES.chartType,
    };
    const indicatorMetricTags = indicator.metrics.map((metric) => ({
        aggregation: t(`sentence:metricAggregations.${metric.aggregation}`),
        value: capitalize(translateBlock(metric.field)),
        type: INDICATOR_TAG_TYPES.metric,
    }));
    const indicatorIntegrationTags = getAvailableFunctionsFromMetrics(
        indicator.metrics,
    ).map((func) => ({
        value: t(`cellar.${func}`),
        type: INDICATOR_TAG_TYPES.connector,
    }));
    const indicatorTags: IndicatorTagT[] = [
        indicatorVizTypeTag,
        ...indicatorIntegrationTags,
        ...indicatorMetricTags,
    ];

    if (isCityIndicator(indicator)) {
        indicatorTags.unshift({
            value: indicator.dashboardTitle,
            type: INDICATOR_TAG_TYPES.title,
        });
    }
    return indicatorTags;
}
